<app-field
  [focused]="focused"
  [dirty]="!empty"
  [disabled]="disabled"
  [showErrorEnabled]="!!showErrorEnabled"
>
  <label label *ngIf="!!label">{{ label }}</label>

  <input
    field
    #inputEl
    [formControl]="formControl"
    [name]="name ?? ''"
    [type]="type"
    [placeholder]="placeholder ?? ''"
    [autocomplete]="autocomplete ? 'on' : 'autocomplete-off'"
    [readonly]="!!readOnly"
    (focus)="onFocusChanged(true)"
    (blur)="onFocusChanged(false)"
    (input)="onInputValue($event)"
    (keydown)="onInputKeydown($event)"
  />

  <app-button
    appFieldSuffix
    *ngIf="isClearButtonVisible"
    buttonType="normal"
    styleType="text"
    shapeType="circle"
    sizeType="x-small"
    icon="assets/icons/xmark.svg"
    (click)="onBtnClearClick($event)"
  ></app-button>

  <ng-container appFieldSuffix>
    <ng-content select="[appFieldSuffix]"></ng-content>
  </ng-container>
</app-field>
